function Counter2_1() {
  return (
    <>
      <circle cx="4.5" cy="8" r="2.5" fill="#404040" />
      <circle cx="11.5" cy="8" r="2.07895" stroke="#404040" strokeWidth="0.842105" />
    </>
  );
}

export default Counter2_1;
